import template from './kform-builder-option-custom-validation.html';

const kformBuilderOptionCustomValidationDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
});

export default kformBuilderOptionCustomValidationDirective;
